export default [
    {
        path: 'geo-reports',
        name: 'frontend.reporting.geo-reports',
        component: () => import(/* webpackChunkName: "GeoReports" */ './GeoReports'),
        meta: {
            headline: () => $t('geoReports.headline'),
            tracking: 'GEO Reports - Page view',
            datepicker: true
        }
    }
]
